import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { DesignMagazineRoomList } from "@/components/features/design/magazine/list/room";

import { useGetParams } from "./hooks/use-get-params";

export const DesignMagazineRoomListPage = () => {
	const { hotelID } = useGetParams();

	return (
		<PageMeta
			title="マガジン記事の一覧 | 部屋記事"
			url={generatePath(PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.LIST.ROOM, { hotelID })}
		>
			<DesignMagazineRoomList hotelID={hotelID} />
		</PageMeta>
	);
};

DesignMagazineRoomListPage.displayName = "DesignMagazineRoomListPage";
